import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React, { FC, ReactNode } from "react";
import { ArrowDownSimpleIcon } from "shared/theme/icons/ArrowDownSimpleIcon";
import {
  COLOR_GREY_6,
  COLOR_GREY_4,
  COLOR_BLACK_60,
} from "shared/theme/colors";
import { AddIcon } from "shared/theme/icons/AddIcon";
import {
  StyledArrowIconWrapper,
  StyledContainer,
  StyledContentSectionButton,
} from "./styled";

type ContentSectionProps = {
  title?: string;
  button?: {
    title: string;
    onClick: () => void;
    icon?: ReactNode;
    color?: string;
    styleAddButton?: boolean;
    disabled?: boolean;
  };
  children: ReactNode;
  collapsed?: boolean;
};

const ContentSection: FC<ContentSectionProps> = ({
  title,
  button,
  children,
  collapsed = false,
}) => {
  const [openContent, setOpenContent] = React.useState(true);

  return (
    <StyledContainer>
      {title && (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb="1rem"
        >
          <Typography
            variant="bodyMSemiBold"
            color={COLOR_BLACK_60}
            letterSpacing="1.4px"
            textTransform="uppercase"
          >
            {title}
          </Typography>
          {collapsed && (
            <StyledArrowIconWrapper
              open={openContent}
              onClick={() => collapsed && setOpenContent(!openContent)}
            >
              <ArrowDownSimpleIcon color={COLOR_GREY_6} size={16} />
            </StyledArrowIconWrapper>
          )}

          {button && (
            <Box m="-0.5rem">
              <StyledContentSectionButton
                variant="text"
                rounded={false}
                icon={
                  button.styleAddButton ? (
                    <AddIcon
                      color={button.disabled ? COLOR_GREY_4 : button.color}
                    />
                  ) : (
                    button.icon
                  )
                }
                leftSideIcon
                title={button.title}
                onClick={button.onClick}
                styleAddButton={button.styleAddButton}
                textColor={button.color}
                disabled={button.disabled}
              />
            </Box>
          )}
        </Box>
      )}
      {openContent && collapsed && <Box>{children}</Box>}
      {!collapsed && openContent && <Box>{children}</Box>}
    </StyledContainer>
  );
};

export default ContentSection;
